// PLUGINS======================================================================================
// import LazyLoad from "vanilla-lazyload";
import Inputmask from "inputmask";
import {Fancybox} from "@fancyapps/ui";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

// MODULES======================================================================================
import "./js-modules/sliders.js";
// import "./js-modules/compare.js";
import "./js-modules/custom-select.js";
import "./js-modules/numbers-animation.js";
import "./js-modules/noUiSlider";

// import initDropdowns from './js-modules/dropdowns'
import Toast from "./js-modules/toast";
import initMobilemenu from "./js-modules/mobilemenu"

import initTabs from "./js-modules/tabs";
import initTolltip from "./js-modules/tooltip";
import Popup from "./js-modules/popup";
import initAnimations from "./js-modules/animations";
import initLoader from "./js-modules/loader.js";
import initShowMore from "./js-modules/show-more.js";
import copyCode from "./js-modules/copy-code.js";
import CustomFile from './js-modules/custom-file'
import initCityToggle from "./js-modules/city-toggle";
import mainBannerAnimate from "./js-modules/main-banner-animate";
import initImgTabs from "./js-modules/img-tabs";

// init ========================================================================================

document.addEventListener("DOMContentLoaded", () => {
    // let lazyload = new LazyLoad()

    // fancybox
    // галерея
    Fancybox.bind("[data-fancybox-gallery]", {
        Toolbar: false,
        dragToClose: false,
        Thumbs: false,
        closeButton: "top",
        mainClass: "fancybox-gallery",
        Carousel: {
            Dots: true,
        },
    })
    // модальное окно
    Fancybox.bind("[data-fancybox-modal]", {
        Toolbar: false,
        dragToClose: false,
        Thumbs: false,
        mainClass: "fancybox-modal"
    })

    // popup
    window.popup = new Popup('[data-popup]')

    // inputmask
    let im = new Inputmask("+7 (999) 999-99-99")
    im.mask(document.querySelectorAll('input[type="tel"]'))

    flatpickr(".default-input__input--date:not([disabled])", {
        "locale": Russian, 
        dateFormat: "d.m.Y",
    });


    // initDropdowns()
    window.toast = new Toast()

    initMobilemenu()

    initTabs()
    initTolltip()
    initAnimations()
    initLoader()
    initShowMore()
    copyCode()
    initCityToggle()
    mainBannerAnimate()
    initImgTabs()

    const customfile = new CustomFile();

    // фиксирование при скролле
    window.onscroll = function() {
        headerScroll()
        compareScroll()
        productNavScroll()
        pageMenuScroll()
    }

    function headerScroll() {
        if (document.body.scrollTop > 35 || document.documentElement.scrollTop > 35) {
            document.querySelector(".header").classList.add('js__scroll');
        } else {
            document.querySelector(".header").classList.remove('js__scroll');
        }
    }

    function compareScroll() {
        let compareBlock = document.querySelector('.compare-slider-wrap')
        if (!compareBlock) return

        let compareTopFixed = document.querySelector('.compare-slider--desc').getBoundingClientRect().top + pageYOffset

        if (document.body.scrollTop > compareTopFixed || document.documentElement.scrollTop > compareTopFixed) {
            document.querySelector(".compare-slider-wrap").classList.add('js__scroll');
        } else {
            document.querySelector(".compare-slider-wrap").classList.remove('js__scroll');
        }
    }

    function productNavScroll() {
        let productNav = document.querySelector('.product-nav')
        if (!productNav) return

        let productNavTopFixed = document.querySelector('.product-card .product-docs').getBoundingClientRect().top + pageYOffset

        if (document.body.scrollTop > productNavTopFixed || document.documentElement.scrollTop > productNavTopFixed) {
            productNav.classList.add('js__scroll');
        } else {
            productNav.classList.remove('js__scroll');
        }
    }

    function pageMenuScroll() {
        let pageMenu = document.querySelector('.page-menu')
        if (!pageMenu) return

        let pageMenuTopFixed = document.querySelector('.about-block').getBoundingClientRect().top + pageYOffset - 110

        if (document.body.scrollTop > pageMenuTopFixed || document.documentElement.scrollTop > pageMenuTopFixed) {
            pageMenu.classList.add('js__scroll');
        } else {
            pageMenu.classList.remove('js__scroll');
        }
    }

    // catalog-nav
    let catalogNav = document.querySelectorAll(".catalog-nav__this");
    if(catalogNav.length) {
        catalogNav.forEach((item) => {
            item.addEventListener("click", (e) => {
                item.classList.toggle("opened")
                item.nextElementSibling.classList.toggle("opened")
                document.body.classList.toggle('catalog-nav-open')
            })
        })
    }

    // news-products 
    let productsBtn = document.querySelector(".news-products__btn");
    if(productsBtn) {
        productsBtn.addEventListener("click", (e) => {
            productsBtn.classList.toggle("opened")
            productsBtn.nextElementSibling.classList.toggle("opened")
            document.body.classList.toggle('news-products-open')
        })
        document.querySelector(".news-products__close").addEventListener("click", (e) => {
            productsBtn.classList.remove("opened")
            productsBtn.nextElementSibling.classList.remove("opened")
            document.body.classList.remove('news-products-open')
        })
    }

    // product-card
    let productCardProdyctsBtn = document.querySelector(".product-card__products-btn");
    if(productCardProdyctsBtn) {
        productCardProdyctsBtn.addEventListener("click", (e) => {
            productCardProdyctsBtn.classList.toggle("js__open")
            productCardProdyctsBtn.nextElementSibling.classList.toggle("js__open")
        })
    }

    // cooperation-form__toggle
    const formBtnsTabs = document.querySelectorAll(".cooperation-form__toggle")
    if (formBtnsTabs) {
        formBtnsTabs.forEach((tabs) => {
            const arr = Array.from(tabs.children)
            const tabPages = document.querySelectorAll('.cooperation-form__list > *')
            arr.forEach((elem) => {
                elem.addEventListener("click", () => {
                    arr.forEach((e) => e.classList.remove("active"))
                    tabPages.forEach((item) => item.classList.remove("active"))

                    elem.classList.add("active")
                    try {
                        tabPages[elem.getAttribute("data-tab-page")].classList.add("active")
                    } catch (e) {
                        console.error(e)
                    }
                })
            })
        })
    }

    // order__list
    let orderBtn = document.querySelectorAll(".order__label");
    if(orderBtn.length) {
        orderBtn.forEach((item) => {
            item.addEventListener("click", (e) => {
                item.classList.toggle("opened")
            })
        })
    }

    // header__catalog-nav
    let catalogLink = document.querySelector('.catalog-link');
    if(catalogLink) {
        catalogLink.addEventListener("mouseover", function(){
            document.querySelector('.header').classList.add('catalog-open')
        });
        catalogLink.addEventListener("mouseout", function(){
            document.querySelector('.header').classList.remove('catalog-open')
        });
    }

})
